/*
 * tasks.js — esbuild IIFE entry
 * Thin wrapper that bundles the already-migrated module with its dependencies.
 * The Sprockets version (app/assets/javascripts/tasks.js) is deleted.
 */
require('./modules/v4/tasks_grid');
